export const UPDATE_SPOT_LIST_FAILURE = 'UPDATE_SPOT_LIST_FAILURE';

export const updateSpotListFailure = (payload: Error) => ({
    type: UPDATE_SPOT_LIST_FAILURE,
    payload,
    error: true,
});
